import loadable from '@loadable/component'

export default [
  {
    path: '/game/GreedyHiya',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GreedyHiya" */ '~/pages/game/GreedyHiya'
        )
    ),
  },
  {
    path: '/game/GreedyHiya/banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GreedyHiya-banner" */ '~/pages/game/GreedyHiya/Activity/Fomo/Banner'
        )
    ),
  },
]
